import './helpers.js';
import App from './App.svelte';

window.addEventListener("load",() => setTimeout(() => window.scrollTo(0, 0), 0));
window.addEventListener("popstate",() => document.querySelector('.modal-backdrop').remove());

let app;

if (location.hostname === 'localhost' || location.hostname === 'app.miin.ru' || true) {
    app = new App({target: document.body});
}

export default app;
